<template>  
<div> <!-- root element start -->
    <div class="container-fluid mt-2">

          <div class="row">
            <div class="col-sm-12 col-md-3">
                <div class="card border-0">
                  <div class="card-header h5 bg-transparent border-0">Options</div>
                  <div class="card-body">
                      <ul class="list-group list-group-flush">
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('product-list', '', '', '')">View Product List</a>
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('item-list', '', '', '')">View Item List</a>
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('product-create', '', '', '')">Add Product</a>
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('product-item-create', '', '', '')">Add Item</a>
                      </ul>
                  </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-9">
              <transition name="slide-fade" mode="out-in">
                <component 
                  :is="rightView" 
                  :prop1="prop1" 
                  :prop2="prop2" 
                  :prop3="prop3" 
                  @onSComplete="successComplete" 
                  @onUComplete="unsuccessComplete"
                >
                </component>
              </transition>
            </div>
           </div>

    </div><!--  end container-fluid div -->
</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/admin-product-main-store.js'


import productList from '../adminProductMainPageComponents/product-list.vue'
import productItemList from '../adminProductMainPageComponents/item-list.vue'
import productCreate from '../adminProductMainPageComponents/product-create.vue'
import productItemCreate from '../adminProductMainPageComponents/product-item-create.vue'


export default {
  store,
  data: function () {
    return { 

    }
  },
  computed: {
    rightView () { return this.$store.state.rightView },
    prop1 () { return this.$store.state.prop1 },
    prop2 () { return this.$store.state.prop2 },
    prop3 () { return this.$store.state.prop3 },
  },
  watch: {
    
  },
  mounted() {
    this.getAllProducts();
    this.getAllProductItems();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    getAllProducts() { this.$store.dispatch("getAllProducts"); },
    getAllProductItems() { this.$store.dispatch("getAllProductItems"); },
    
    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
        _this.getAllProducts();
        _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
          _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },

  },    
  components:{
    'product-list': productList,
    'item-list': productItemList,
    'product-create': productCreate,
    'product-item-create': productItemCreate,
    
  },
  filters: {

  }
}
</script>
